var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "main-banner" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "menu-bar" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.status != "signin" &&
          _vm.$store.getters.getSessionId != null &&
          _vm.$store.getters.getSessionId != ""
            ? _c("div", [
                _c("p", [_vm._v(_vm._s(_vm.$store.getters.getEmail))]),
                _vm._v(" "),
                _c("p", { staticClass: "v-line-blue" }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass: "btn",
                    on: {
                      click: function ($event) {
                        return _vm.handleSignoutClick()
                      },
                    },
                  },
                  [_vm._v("推出")]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "big-title" }, [
          _vm._v(
            "\n                " + _vm._s(_vm.l10.Coupon_Title1.slice(0, 7))
          ),
          _c("br", { staticClass: "mobile-show" }),
          _vm._v(_vm._s(_vm.l10.Coupon_Title1.slice(7)) + "\n            "),
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "title-deco",
          attrs: {
            src: require("@/assets/coupon/img/img-coupon-logo.svg"),
            alt: "Todo English Main Banner Logo",
          },
        }),
        _vm._v(" "),
        !_vm.isMobileOnly
          ? _c("img", {
              staticClass: "img_students",
              attrs: { src: require("@/assets/coupon/img/img-students.svg") },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("img", {
          staticClass: "img_students_m mobile-show",
          attrs: {
            src: require("@/assets/coupon/img/img-coupon-students-m.svg"),
          },
        }),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "promo1" } }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          {
            class:
              _vm.status == "signin" ||
              _vm.status == "recover" ||
              _vm.status == "signup"
                ? "current"
                : "",
          },
          [
            _c("p", { staticClass: "text" }, [
              _c("span", { staticStyle: { "font-weight": "600" } }, [
                _vm._v("Step 1."),
              ]),
              _c("br"),
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.l10.Coupon_Title2) +
                  "\n                "
              ),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { class: _vm.status == "coupon" ? "current" : "" }, [
          _c("p", { staticClass: "text" }, [
            _c("span", { staticStyle: { "font-weight": "600" } }, [
              _vm._v("Step 2."),
            ]),
            _c("br"),
            _vm._v(
              "\n                    " +
                _vm._s(_vm.l10.Coupon_Title3) +
                "\n                "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { class: _vm.status == "complete" ? "current" : "" }, [
          _c("p", { staticClass: "text" }, [
            _c("span", { staticStyle: { "font-weight": "600" } }, [
              _vm._v("Step 3."),
            ]),
            _c("br"),
            _vm._v(
              "\n                    " +
                _vm._s(_vm.l10.Coupon_Title4) +
                "\n                "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "logo" }, [
      _c("img", {
        staticClass: "english-logo",
        attrs: { src: require("@/assets/coupon/img/img-coupon-logo-cn.svg") },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }